import { getOverweightFactor } from './overweight'

// undersupply beyond 1 unit is always an anomaly;
// oversupply is allowed up to the product CollectDeviation percent.
const isOverPacks = (row) =>
    row.SupplyQty > row.OrderPacks * getOverweightFactor(row.CollectDeviation)

const isOffWeight = (row) => {
    const perUnit = row.SupplyWeight / row.SupplyQty
    const factor = getOverweightFactor(row.CollectDeviation)
    const gaveLess = (row.OrderWeight - row.SupplyWeight) > perUnit
    const gaveMore = (row.SupplyWeight - row.OrderWeight * factor) > perUnit
    return gaveLess || gaveMore
}

export const passOrderRowsIntoOrder = (arr) => {

    let reducedDetalis = arr.reduce((acc, cur) => {
        if(cur.SupplyQty > 0 || cur.ChangeReason !== 0) {
            cur.IsProblemRow = isOverPacks(cur)
            acc[cur.OrderID] = acc[cur.OrderID]?.concat(cur) || [].concat(cur)
        }
        return acc
    }, {})

    return reducedDetalis
}

export const passOrderRowsIntoOrderByWeight = (arr) => {

        let reducedDetalis = arr.reduce((acc, cur) => {
            if(cur.SupplyWeight > 0 || cur.ChangeReason !== 0) {
                cur.IsProblemRow = isOffWeight(cur)
                acc[cur.OrderID] = acc[cur.OrderID]?.concat(cur) || [].concat(cur)
            }
            return acc
        }, {})

        return reducedDetalis
}

export const passTeudotIntoOrder = (arr) => {
    let reduced = arr.reduce((acc, cur) => {
        acc[cur.Order_Num] = acc[cur.Order_Num]?.concat(cur) || [].concat(cur)
        return acc
    }, {})

    return reduced
}
